export { default } from './AppResourcesPanel.vue'
